// extracted by mini-css-extract-plugin
export default {"item":"ApptSurvey_modal_item__x-Jom","buttons":"ApptSurvey_modal_buttons__SjWzp"};